import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-126">
      <div className="max-w-2xl mx-auto text-center" data-id="element-127">
        <div className="text-8xl mb-6" data-id="element-128">🛡️</div>

        <h2 className="text-3xl sm:text-4xl font-black text-[#F97316] mb-4" data-id="element-129">
          GARANTÍA MEGAPACK BOXEO LISTO — 7 DÍAS
        </h2>

        <div className="bg-[#0d0700] border-2 border-[#F97316] rounded-2xl p-8 mb-6" data-id="element-130">
          <p className="text-white text-lg mb-4 leading-relaxed" data-id="element-131">
            Abres los 6 tomos. Revisas los 6 bonos. Los usas en tu próxima clase
            si quieres.
          </p>
          <p className="text-white text-lg mb-6 leading-relaxed" data-id="element-132">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-[#F97316] text-3xl font-black mb-4" data-id="element-133">
            Te devolvemos el 100%.
          </p>
          <p className="text-white text-xl font-bold" data-id="element-134">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-135">
          La confianza que tenemos en el MegaPack Boxeo Listo nos permite hacer
          esa promesa sin dudar.
          <br data-id="element-136" />
          Más de 500 entrenadores de todo el mundo hispanohablante ya lo saben.
          <br data-id="element-137" />
          La tasa de devoluciones es menor al 1%.
        </p>
      </div>
    </section>;
}